/**
 * Tiny placeholder plugin: when the doc is empty, render the placeholder text
 * as a decoration on the first (and only) paragraph. We compare the doc to the
 * canonical empty shape so we don't flash a placeholder when the user has e.g.
 * typed a single character.
 */
import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

export const placeholderPluginKey = new PluginKey('pmPlaceholder');

export function buildPlaceholderPlugin(getPlaceholder: () => string) {
  return new Plugin({
    key: placeholderPluginKey,
    props: {
      decorations(state) {
        const { doc } = state;
        // Empty = a single empty paragraph as the only child.
        if (doc.childCount !== 1) return null;
        const first = doc.firstChild;
        if (!first || first.type.name !== 'paragraph' || first.content.size > 0) return null;
        const placeholder = getPlaceholder();
        if (!placeholder) return null;
        const deco = Decoration.node(0, first.nodeSize, {
          class: 'pm-empty',
          'data-placeholder': placeholder,
        });
        return DecorationSet.create(doc, [deco]);
      },
    },
  });
}
